import React from 'react';
import { useI18nContext } from '@ecg-marktplaats/js-react-i18n';

import Classes from './SellReasons.scss';

const REASON_KEYS = ['reason1', 'reason2', 'reason3'] as const;

const SellReasons = () => {
  const { t } = useI18nContext();

  return (
    <section className={`PageContent-card PageContent-offset ${Classes.root}`}>
      <div className={Classes.heading}>
        <h2 className={Classes.title}>{t('sell.page.reasons.title')}</h2>
        <p className={Classes.subtitle}>{t('sell.page.reasons.subtitle')}</p>
      </div>
      <div className={Classes.reasons}>
        {REASON_KEYS.map((key) => (
          <div key={key} className={Classes.reason}>
            {/* TODO: replace with <Image> once assets land in src/client/images/cars-sell/ */}
            <div className={Classes.imagePlaceholder} aria-hidden="true" />
            <h3 className={Classes.reasonTitle}>{t(`sell.page.reasons.${key}.title`)}</h3>
            <p className={Classes.reasonBody}>{t(`sell.page.reasons.${key}.body`)}</p>
          </div>
        ))}
      </div>
    </section>
  );
};

export default SellReasons;
